"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugDevice = void 0;
const events_1 = require("events");
class ButtplugDevice extends events_1.EventEmitter {
    constructor(aProtocol, aDevice) {
        super();
        this.ParseMessage = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            return yield this._protocol.ParseMessage(aMsg);
        });
        this._protocol = aProtocol;
        this._device = aDevice;
        this._device.addListener("deviceremoved", () => {
            // TODO Do we really have to pass ourselves here?
            this.emit("deviceremoved", this);
        });
    }
    get Connected() {
        return this._device.Connected;
    }
    get MessageSpecifications() {
        return this._protocol.MessageSpecifications;
    }
    Disconnect() {
        return this._device.Disconnect();
    }
    Initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._protocol.Initialize();
        });
    }
    get Name() {
        return this._protocol.Name;
    }
    get Id() {
        return this._device.Address;
    }
}
exports.ButtplugDevice = ButtplugDevice;
//# sourceMappingURL=ButtplugDevice.js.map